import * as z from 'zod';

export const SpeakerSchema = z.enum(['vera', 'parent']);
export type Speaker = z.infer<typeof SpeakerSchema>;

export const TurnSchema = z.object({
  speaker: SpeakerSchema,
  text: z.string().min(1),
});
export type Turn = z.infer<typeof TurnSchema>;

export const TranscriptSchema = z.array(TurnSchema).min(1);
export type Transcript = z.infer<typeof TranscriptSchema>;

const SPEAKER_LABEL: Record<Speaker, string> = { vera: 'Вера', parent: 'Собеседник' };

/** Plain-text rendering that is sent to the summary model. */
export function renderTranscript(transcript: Transcript): string {
  return transcript.map((turn) => `${SPEAKER_LABEL[turn.speaker]}: ${turn.text}`).join('\n');
}

/**
 * Only what the parent said. Evidence for an alarm must come from here:
 * Vera's own questions ("Не падали?") are never evidence.
 */
export function parentSpeech(transcript: Transcript): string {
  return transcript
    .filter((turn) => turn.speaker === 'parent')
    .map((turn) => turn.text)
    .join('\n');
}
